export * from './lib/components/chat-interaction/chat-interaction.component';
export * from './lib/components/training-phrases-field/training-phrases-field.component';